// assets/js/geo-routing.js

import lottie from 'lottie-web';
// Adapte ce chemin selon ta structure réelle
import globeAnimationData from '../lottie/globe.json'; 

export function initGeoRouting() {

    // --- CONFIGURATION ---
    const COOKIE_NAME = 'hitech_geo_pref';
    const API_URL = '/wp-json/hitech/v1/detect-country';
    const DOMAIN_CH = 'hi-technologies.ch';
    const DOMAIN_FR = 'hi-technologies.fr'; // ✅ PROD ACTIVÉE

    const overlay = document.getElementById('hitech-geo-overlay');
    if (!overlay) return; 

    // --- MAPPING (Pages autorisées) ---
    const PAGE_MAPPING = {
        '/': '/',
        '/fr/': '/fr/',
        '/en/': '/en/',
        '/contact/': '/contact/',
        '/fr/contact/': '/fr/contact/',
        '/en/contact/': '/en/contact/',
        '/support/': '/support/',
        '/fr/support/': '/fr/support/',
        '/en/support/': '/en/support/'
    };

    // 1. Check Cookie (Déjà vu ?)
    // Si l'utilisateur a déjà choisi, on ne l'embête plus.
    if (document.cookie.split(';').some((item) => item.trim().startsWith(COOKIE_NAME + '='))) {
        return; 
    }

    // 2. Contexte (Où suis-je ?)
    const currentHost = window.location.hostname;
    const currentPath = window.location.pathname;
    let isSiteCH = currentHost.includes('.ch');
    let isSiteFR = currentHost.includes('.fr');

    // Sécurité Mapping : Uniquement sur les pages définies pour éviter les 404
    // (Note: Sur le site FR, on est plus souple car on renvoie vers la home CH souvent)
    if (isSiteCH && !PAGE_MAPPING.hasOwnProperty(currentPath)) {
        // console.log('GeoIP: Page non mappée (Ignoré).');
        return;
    }

    // 3. Init Lottie
    let animationInstance = null;
    const lottieContainer = document.getElementById('geo-lottie');
    
    if (lottieContainer) {
        animationInstance = lottie.loadAnimation({
            container: lottieContainer,
            renderer: 'svg',
            loop: true,
            autoplay: false,
            animationData: globeAnimationData
        });
    }

    // 4. Appel API
    fetch(API_URL)
        .then(res => res.json())
        .then(data => {
            if (!data || !data.detected) return;
            
            const userCountry = data.country; 
            const texts = overlay.dataset;

            // CAS 1 : FR sur CH
            if (userCountry === 'FR' && isSiteCH) {
                // On redirige vers la page équivalente si elle existe, sinon Home FR
                const targetPath = PAGE_MAPPING[currentPath] || '/';
                const targetUrl = `https://${DOMAIN_FR}${targetPath}`;
                showOverlay(texts.msgFrOnCh, texts.btnFrOnCh, targetUrl, texts.btnStayFrOnCh);
            }
            // CAS 2 : CH sur FR
            else if (userCountry === 'CH' && isSiteFR) {
                // On renvoie vers la même page sur le .ch
                const targetUrl = `https://${DOMAIN_CH}${currentPath}`;
                showOverlay(texts.msgChFr, texts.btnChFr, targetUrl, texts.btnStayChFr);
            }
        })
        .catch(err => console.error(err));

    // Fonction d'affichage
    function showOverlay(message, btnLabel, url, stayLabel) {
        const content = document.getElementById('hitech-geo-content');
        const txtMsg = document.getElementById('geo-overlay-message');
        const btnSwitch = document.getElementById('btn-geo-switch');
        const btnText = document.getElementById('geo-btn-text');
        const btnStayText = document.getElementById('geo-btn-stay-text');

        txtMsg.innerHTML = message;
        btnText.textContent = btnLabel;
        btnSwitch.href = url;

        if (stayLabel && btnStayText) {
            btnStayText.textContent = stayLabel;
        }

        overlay.classList.remove('hidden');
        
        if (animationInstance) animationInstance.play();

        requestAnimationFrame(() => {
            overlay.classList.remove('opacity-0');
            content.classList.remove('scale-95', 'opacity-0');
            content.classList.add('scale-100', 'opacity-100');
        });

        document.getElementById('btn-geo-stay').onclick = () => closeOverlay('stay');
        btnSwitch.onclick = () => closeOverlay('switch');
    }

    function closeOverlay(action) {
        const remember = document.getElementById('geo-remember').checked;
        let expires = "";
        
        if (remember) {
            const date = new Date();
            date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        
        document.cookie = `${COOKIE_NAME}=${action}${expires}; path=/; SameSite=Lax`;

        overlay.classList.add('opacity-0'); // Fade out visuel d'abord
        setTimeout(() => {
             overlay.classList.add('hidden');
        }, 300);
    }
}